// extracted by mini-css-extract-plugin
module.exports = {"title":"panel-content-large_title__CAZLu"};